import { memo } from "react";

import { MessageAttachment } from "shared/functions/fileToText";

import "./MessageAttachments.css";

function formatSize(length: number): string {
  if (length < 1000) return `${length} chars`;
  return `${(length / 1000).toFixed(1)}K chars`;
}

// Chips de adjuntos dentro del transcript: muestran que un bloque
// (archivo o texto pegado) viajó SEPARADO del input del usuario.
// Colapsados por default; expandibles para inspeccionar el contenido.
function MessageAttachments(props: { attachments: MessageAttachment[] }) {
  if (!props.attachments.length) return null;
  return (
    <div className="message-attachments">
      {props.attachments.map((attachment, index) => (
        <details
          key={`${attachment.name}-${index}`}
          className="message-attachment"
        >
          <summary title={attachment.name}>
            <span className="message-attachment-name">{attachment.name}</span>
            <span className="message-attachment-size">
              {formatSize(attachment.text.length)}
            </span>
          </summary>
          <pre>{attachment.text}</pre>
        </details>
      ))}
    </div>
  );
}

export default memo(MessageAttachments);
